import styled from "@emotion/styled";
import { COLOR_BLACK_10 } from "shared/theme/colors";

export const SkeletonContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  & > div {
    gap: 16px;
  }
`;

export const StyledAnimatedSkeleton = styled("div")`
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: 10px;
  background-color: ${COLOR_BLACK_10};
  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

export const ModuleTitleSkeleton = styled(StyledAnimatedSkeleton)`
  height: 24px;
  width: 250px;
  border-radius: 100px;
`;

export const ModuleTypeSkeleton = styled(StyledAnimatedSkeleton)`
  height: 24px;
  width: 98px;
  border-radius: 100px;
`;

export const ModuleScheduleSkeleton = styled(StyledAnimatedSkeleton)`
  height: 24px;
  width: 95px;
  border-radius: 100px;
`;

export const ModuleActionSkeleton = styled(StyledAnimatedSkeleton)`
  height: 24px;
  width: 24px;
  border-radius: 100px;
`;
